module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "font-size": "2em!important",
      "margin-top": "4em!important",
      "margin-bottom": "3em!important"
    },
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/07_toc#ack"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("I am deeply grateful to the many people who helped in this project. Some, in fact, were absolutely instrumental in bringing it to life. I am grateful to them all, but first of all, I thank my wife, Valentina. She was as always the first reader and gave daily support and encouragement as well as valuable ideas and comments.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Without William Green, a Washingtonian and an American in the very best sense of this word, this book would never have seen the light of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("My British publisher, Michael Leventhal, entrusted me this project and was patient and understanding as it progressed.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("As often happens, there are people who, unfortunately, cannot be named, but whose opinion and friendly advice were important for the better understanding of many processes behind the scenes. Thank you, Jim and Richard, for kindly sharing your vast experience.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("After Tennent H. (‘Pete’) Bagley published his "), _c('em', [_vm._v("Spy Wars")]), _vm._v(", he agreed to spend time and effort reading and correcting the text. My gratitude to Pete is profound while any errors that remain are exclusively my fault.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I thank Alex Goldfarb and Marina Litvinenko for the many hours they have spent with me discussing the case.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Two journalists and authors, Steve LeVine and Pete Earley, helped a lot. And the outstanding historians (and good friends) Professor Paul Preston of the London School of Economics and Professor Angel Viñas of the University of Madrid (Complutense) provided great support and help.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Another good friend, Paolo Guzzanti, member of the Italian parliament and former President of the Mitrokhin Commission, helped unlock many doors to better understanding of the Italian part of the Litvinenko story and of the people and events involved. Pal Salamon of the Open Society Archives in Budapest sent me many documents pertinent to the Lapusnyik case. Alexandra Bajka kindly provided footage from the latest documentary filmed by her Polish TVN television channel that threw new light on the life and death of Nikolai Artamonov. Max Fisher of the Windfall Films, London, kindly gave video material covering the Markov case in its modern perspective. And many thanks to Michael Mann, a "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("famous Hollywood film director, screenwriter and producer, and his assistant Maria Norman, for all they did.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I was buoyed up by the interest, encouragement and good humour these men and women showed me throughout the months of research and writing. Without them I could not have done it. Thank you!")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb04438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/09_acknowledgement.vue
// module id = 75
// module chunks = 0